<template>
  <div class="payment-plan">
    <el-row>
      <p class="title">{{ $t('plan_payment.payment_plan.title') }}</p>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="17">
        <p>{{ $t('plan_payment.payment_plan.select_a_plan') }}</p>
      </el-col>
      <el-col :span="6">
        <p>{{ $t('plan_payment.payment_plan.number_of_users') }}</p>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="17">
        <el-select @change="handleProductChange" v-model="form.product">
          <el-option
            v-for="product in products"
            :key="product.id"
            :label="product.label"
            :value="product.id"
          >
            <span style="float: left">{{ product.label }}</span>
            <span style="float: right; color: #979797;">
              {{ product.code.includes('b2bmedium') ? '51-100 users' : '5-50 users' }}
            </span>
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="6">
        <vue-numeric-input
          :max="101"
          :min="0"
          :value="quantity"
          @blur="onQuantityBlur"
          @change="onQuantityChange"
          autofocus
          ref="numericInput"
        />
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col v-if="selectedProduct" :span="24">
        <p class="sub-title">{{ $t('plan_payment.payment_plan.your_benefits') }}</p>
        <div class="benefit" v-for="(item, idx) in benefits[selectedProduct['catalog_code']]" :key="idx">
          <img src="@/assets/images/tick.svg" alt=""/>
          {{ item.description }}
        </div>
        <!-- <div class="benefit disabled" v-for="(item, idx) in benefits[discountCode]['off']" :key="'off'+idx">
          <img src="@/assets/images/tick-disabled.svg" alt=""/>
          {{ item }}
        </div> -->
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import VueNumericInput from 'vue-numeric-input';
  import { DISCOUNT_CODE } from '@/constants/generic';

  export default {
    components: {
      VueNumericInput
    },
    props: ['products', 'country', 'benefits'],
    data () {
      return {
        quantity: 0,
        selectedProduct: undefined,
        quantityRange: {
          [DISCOUNT_CODE.LITE.toLowerCase()]: {
            min: 5,
            max: 50
          },
          [DISCOUNT_CODE.MEDIUM.toLowerCase()]: {
            min: 51,
            max: 101
          }
        },
        form: {
          package: undefined,
          quantity: 5,
          product: undefined,
          currency: 'USD',
          price: 0,
          saving: 0,
          title: '',
        }
      };
    },
    methods: {
      setFormData () {
        this.form.currency = this.selectedProduct.currency.toUpperCase();
        this.form.product = this.selectedProduct.id;
        this.form.price = this.selectedProduct.price;
        this.form.package = this.selectedProduct.package;
        this.form.saving = this.savingAmount;
        this.form.interval = this.selectedProduct.interval;
        this.form.product_types = [this.selectedProduct.catalog_code];
        this.form.product_content = this.selectedProduct.product_content;
        this.form.product_content_ids = this.selectedProduct.product_content_ids;
        this.form.title = this.selectedProduct.label;
        // adjust quantity base on min max
        if (this.form.quantity > 100) {
          this.form.quantity = 100;
        } else if (this.form.quantity > this.max) {
          this.form.quantity = this.max;
        } else if (this.form.quantity < this.min) {
          this.form.quantity = this.min;
        }
        this.quantity = this.form.quantity;
      },
      handleProductChange (value) {
        this.selectedProduct = this.products.find(product => product.id === value);
        this.setFormData();
        this.updateProduct();
      },
      handleQuantityChange (value) {
        if (value > 100) {
          value = 100;
        } else if (value > this.max) {
          value = this.max;
        } else if (value < this.min) {
          value = this.min;
        }
        this.quantity = value;
        this.form.quantity = value;
        this.$refs.numericInput.newValue = value;
        this.updateProduct();
      },
      onQuantityChange (newValue) {
        this.handleQuantityChange(newValue);
      },
      onQuantityBlur () {
        this.handleQuantityChange(this.quantity);
      },
      updateProduct () {
        this.$emit('set-product', this.form);
      }
    },
    computed: {
      amount () {
        return this.selectedProduct.price * this.quantity;
      },
      savingAmount () {
        return (this.selectedProduct.base_price * this.quantity) - this.amount;
      },
      min () {
        return this.quantityRange[this.discountCode].min || 1;
      },
      max () {
        return this.quantityRange[this.discountCode].max || 100;
      },
      discountCode () {
        // find discount code from product code
        if (this.selectedProduct && this.selectedProduct.code) {
          if (this.selectedProduct.code.includes(DISCOUNT_CODE.LITE.toLowerCase())) {
            return DISCOUNT_CODE.LITE.toLowerCase();
          } else if (this.selectedProduct.code.includes(DISCOUNT_CODE.MEDIUM.toLowerCase())) {
            return DISCOUNT_CODE.MEDIUM.toLowerCase();
          } else {
            return DISCOUNT_CODE.MEDIUM.toLowerCase();
          }
        } else {
          return DISCOUNT_CODE.MEDIUM.toLowerCase();
        }
      }
    },
  };
</script>

<style lang="scss" scoped>
  h1 {
    letter-spacing: unset !important;
  }

  p {
    font-size: 18px;
  }

  .benefit {
    display: flex;
    align-items: center;
    padding-bottom: 10px;

    img {
      padding-right: 10px;
    }

    &.disabled {
      color: #979797;
    }
  }

  .title {
    font-size: 24px;
    line-height: 120%;
    font-weight: bold;
    color: #333333;
    letter-spacing: unset;
  }

  .sub-title {
    line-height: 185%;
    font-weight: bold;
    color: #333333;
  }

  ::v-deep .vue-numeric-input {
    width: 161px;
    height: 56px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid rgba(0, 0, 0, 0.2) !important;
    border-radius: 55px;

    button {
      box-shadow: unset;
      background: unset;
      transition: unset;
      border: unset;
    }

    .numeric-input {
      border-radius: 55px;
      border: unset;
      height: 33px;
      text-align: center !important;
      font-size: 18px;
      line-height: 28px;
      padding: 0;
    }

    .btn-increment {
      width: 18px;
      margin-right: 22px;
    }

    .btn-decrement {
      width: 18px;
      margin-left: 22px;
    }
  }

  ::v-deep .el-select {
    .el-input__inner {
      background: #FFFFFF;
      border-radius: 55px;
      font-weight: 500;
      font-size: 20px;
      line-height: 30px;
      color: #478DFF;
      width: 400px;
      height: 56px;
      padding: 0 27px;
      font-family: "SF Pro Display", sans-serif;
    }

    .el-input__suffix {
      right: 20px;
    }

    .el-select__caret {
      color: #478DFF;
    }
  }
</style>
